import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-response-headers',
  templateUrl: './response-headers.component.html',
  styleUrls: ['./response-headers.component.scss']
})
export class ResponseHeadersComponent implements OnInit {

  @Input() responseHeaders: any;
  constructor() { }

  ngOnInit() {
  }

  addResponseHeader() {
    if (!this.responseHeaders) {
      this.responseHeaders = [];
    }
    this.responseHeaders.push({
      name: '',
      value: ''
    });
  }

  removeResponseHeader(index) {
    if (confirm('Are you sure you want remove this header?')) {
      this.responseHeaders.splice(index, 1);
    }
  }
}
